import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, ISearchSort, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import * as _ from "lodash";
import {SalesAreaSearch} from "./SalesAreaSearch";

class ProductGroupSearchByMDSetSearchProvider
    implements ISearchProvider {
    _wbMDSetId: number = undefined
    _view: any = {
        WB_MDSET_ID: {
            type: SearchProviderFieldType.number,
            renderOptions: {columnName: 'Master Data Set WB Id', columnResourceName: 'colMDSetWbId', alignment: HorizAlignment.Center},
            domainOptions: {}
        },
        WB_PRDGRP_ID: {
            type: SearchProviderFieldType.number,
            renderOptions: {columnName: 'Id', columnResourceName: 'colWbId', alignment: HorizAlignment.Center},
            domainOptions: {}
        },
        PRODUCT_GROUP_ID: {
            type: SearchProviderFieldType.string,
            renderOptions: {columnName: 'PG Id', columnResourceName: 'colPGId', alignment: HorizAlignment.Left},
            domainOptions: {maxLength: 50}
        },
        PRODUCT_GROUP_NAME: {
            type: SearchProviderFieldType.string,
            renderOptions: {columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
            domainOptions: {maxLength: 50}
        },
        LEVEL_ID: {
            type: SearchProviderFieldType.string,
            renderOptions: {columnName: 'Level', columnResourceName: 'colLevel', alignment: HorizAlignment.Left},
            domainOptions: {domainIds: "ProductGroup_Level", useIdAsKey: true, maxLength: 50}
        },
        STATUS_CODE: {
            type: SearchProviderFieldType.string,
            renderOptions: {columnName: 'Status', columnResourceName: 'colStatus', alignment: HorizAlignment.Left},
            domainOptions: {maxLength: 50}
        },
        SOURCE_ID: {
            type: SearchProviderFieldType.string,
            renderOptions: {
                columnName: 'Source ID',
                columnResourceName: 'colSourceID',
                alignment: HorizAlignment.Left
            },
            domainOptions: {maxLength: 50}
        },
        PRODUCT_GROUP_SET_ID: {
            type: SearchProviderFieldType.string,
            renderOptions: {
                columnName: 'Product Group Set ID',
                columnResourceName: 'colProductGroupSetID',
                alignment: HorizAlignment.Left
            },
            domainOptions: {maxLength: 50}
        },
        PLANNED_IND: {
            type: SearchProviderFieldType.boolean,
            renderOptions: {
                columnName: 'Planned',
                columnResourceName: 'colPlanned',
                alignment: HorizAlignment.Center
            },
            domainOptions: {maxLength: 1}
        },
        TYPE_ID: {
            type: SearchProviderFieldType.string,
            renderOptions: {
                columnName: 'Type Id',
                columnResourceName: 'colTPMPrdGroupTypeId',
                alignment: HorizAlignment.Left
            },
            domainOptions: {domainIds: "ProductGroup_Type", useIdAsKey: true, maxLength: 50}
        },
        SUBTYPE_ID: {
            type: SearchProviderFieldType.string,
            renderOptions: {
                columnName: 'Sub Type Id',
                columnResourceName: 'colTPMPrdGroupSubTypeId',
                alignment: HorizAlignment.Left
            },
            domainOptions: {domainIds: "ProductGroup_SubType", useIdAsKey: true, maxLength: 50}
        },
        ALL_SALES_AREAS: {
            type: SearchProviderFieldType.string,
            renderOptions: {
                columnName: 'Sales Area',
                columnResourceName: 'colPrdGrpSalesArea',
                alignment: HorizAlignment.Left
            },
            domainOptions: {maxLength: 256}
        },
        PRODUCT_TYPE: {
            type: SearchProviderFieldType.string,
            renderOptions: {
                columnName: 'Product Type',
                columnResourceName: 'colProductTypes',
                alignment: HorizAlignment.Left
            },
            domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
        },
        WB_SALESAREA_ID: {
            type: SearchProviderFieldType.string,
            renderOptions: {
                columnName: 'Sales Area WB Id',
                columnResourceName: 'colCustSARWBId',
                alignment: HorizAlignment.Center
            },
            domainOptions: {
                maxLength: 256,
                search: SalesAreaSearch,
                profileId: "default",
                searchCondition:{}
            }
        },
        WB_ENTITY_ID: {
            type: SearchProviderFieldType.string,
            renderOptions: {
                columnName: 'Entity WB Id',
                columnResourceName: 'colEntityWBId',
                alignment: HorizAlignment.Center
            },
            domainOptions: {
                maxLength: 256
            }
        }
    }

    constructor(wbMDSetId?: number) {
        this._wbMDSetId = wbMDSetId
        this._view.WB_SALESAREA_ID.domainOptions.searchCondition = {WB_MDSET_ID: this._wbMDSetId}
    }


    keyFields = {
        id: 'WB_PRDGRP_ID',
        id_ui: 'PRODUCT_GROUP_ID',
        name: 'PRODUCT_GROUP_NAME'
    }

    searchProviderFields = this._view

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            if (this._wbMDSetId > 0)
                searchOptions.where.WB_MDSET_ID = this._wbMDSetId


            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_ProductGroup_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    let returnVals: any[] = _.uniqBy(res, aRes => aRes.WB_PRDGRP_ID)
                    resolve(returnVals)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let query: { where: { [id: string]: any } } = {where: {}}
            if (this._wbMDSetId > 0)
                query.where.WB_MDSET_ID = this._wbMDSetId

            let findRequest = SearchUtils.makeSearchRequest(query,
                'vUI_ProductGroup_Search',
                this.searchProviderFields,
                [fieldName])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}


class ProductGroupSearchByMDSetProfile
    implements ISearchProfile {
    aSearchProvider: ISearchProvider = undefined
    profileId = "default"
    profileName = "Search by Id, Name"
    renderOptions = {ui5ResourceId: "ProductGroupByMDSetSearchProfileByName"}

    profileFilter = [
        {profileFilterName: 'Id', searchProviderFieldId: 'PRODUCT_GROUP_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'PRODUCT_GROUP_NAME', renderOptions: {}},
        {profileFilterName: 'Level', searchProviderFieldId: 'LEVEL_ID', bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Type', searchProviderFieldId: 'PRODUCT_TYPE', bMultiSelect: true, renderOptions: {}},
        {
            profileFilterName: 'Sales Area',
            searchProviderFieldId: 'WB_SALESAREA_ID',
            bMultiSelect: true,
            renderOptions: {}
        }
    ] // ISearchFields
    profileDisplayFields = [
        'PRODUCT_GROUP_ID', 'PRODUCT_GROUP_NAME', 'LEVEL_ID', 'PRODUCT_TYPE', 'ALL_SALES_AREAS'
    ] //string[];   // Search Provider Field Name (Use to Generate Grid Columns)


    profileTreeIdDefault = "default"
    profileTrees = [
        {
            treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {
                defaultValues: "Tree Path not set",
                levelDelimiter: "\\",
                ruggedTree: true
            })],
            renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}
        }
    ]
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault = ""    //string;
    profileSorts: ISearchSort[] = [] //ISearchSort[];

    constructor(wbMDSetId: number) {
        this.aSearchProvider = new ProductGroupSearchByMDSetSearchProvider(wbMDSetId)
    }

    get profileSearchProvider() {
        return this.aSearchProvider
    }

};


export class ProductGroupSearchByMDSet
    implements ISearch {
    constructor(wbMDSetId?: number) {
        this.searchProfiles = [new ProductGroupSearchByMDSetProfile(wbMDSetId)]
    }

    searchName = "Find Product Group"
    renderOptions = {ui5ResourceId: "ProductGroupSearchByMDSetSearch"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []

};
